import React from 'react';
import c from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../Card';
import { TargetAudienceCardProps } from '../Card/types';

import fallbackIllustration from '../../assets/images/illustrations/primary/ouders.svg';

import './style.scss';

const TargetAudienceCard: React.FC<TargetAudienceCardProps> = (props) => {
  const {
    type = 'primary',
    title,
    subtitle,
    image,
    link,
    className,
  } = props;

  const classNames = c('TargetAudienceCard', `TargetAudienceCard--${type}`, 'u-focus-ring--within', 'u-link-box', className);

  return (
    <Card className={classNames}>
      <Card.Content>
        <Card.Image image={image} fallbackIllustration={fallbackIllustration} />

        <CoreLink href={link}>
          <div className="TargetAudienceCard__link">
            <Card.Title title={title} />
            <Icon name="chevron_right" />
          </div>
        </CoreLink>

        <Card.Subtitle subtitle={subtitle} isTruncated={false} />
      </Card.Content>
    </Card>
  );
};

export default TargetAudienceCard;
